module.exports = __webpack_public_path__ + "images/avatars/female/5.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/5.png
// module id = KxLd
// module chunks = 118